module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADmSURBVEhL7dU7CsJQEIXhFNq7Ax9bsHELYiNa2boGN6GtjeAKxEp3oVZuwweI2Iii/icYCOZ1w00KxQMfONyZO4FAdP4hHWxxwRotZJYuHnh+aMIqBQxxhi7coITBu17BKiP4n1i0sPj+fYVVdvhcsIfi1bnlhxd4B1kJJKzJRiBhTTZCE3tokMT53BecoIaKW6VLGZrVHZFZQE0Tt0qXMTS7dKuI1KHviBqnqCIpenJdrq/qHQ3EpgdvSRo39GEU/WmkWaLL2zCKf/CAuBeuM/X4ZxKjpiNmMHkHNcyhGaMF3xTHeQHql54GAloTUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-bathtub/dark/24.png
// module id = 1878
// module chunks = 2